import { render, staticRenderFns } from "./ProductISOCountryReview.vue?vue&type=template&id=768d6d54&"
import script from "./ProductISOCountryReview.vue?vue&type=script&lang=js&"
export * from "./ProductISOCountryReview.vue?vue&type=script&lang=js&"
import style0 from "./ProductISOCountryReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductISOCountryReview.vue"
export default component.exports